import { render, staticRenderFns } from "./AdminStaffManager.vue?vue&type=template&id=1928dcfc&scoped=true"
import script from "./AdminStaffManager.vue?vue&type=script&lang=js"
export * from "./AdminStaffManager.vue?vue&type=script&lang=js"
import style0 from "./AdminStaffManager.vue?vue&type=style&index=0&id=1928dcfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1928dcfc",
  null
  
)

export default component.exports